query PlatformCustomCover($id: ID!) {
  platformCustomCover(id: $id) {
    id
    title {
      text
      color
      size
      weight
    }
    subTitle {
      text
      color
      size
      weight
    }
    buttons {
      text
      link
      variant
      disabled
    }
    buttonsColor
    buttonsSize
    brightness
    background {
      mobileImageId
      desktopImageId
      mobileVideoId
      desktopVideoId
    }
    align
    alignMobile
    verticalAlign
    verticalAlignMobile
    publishAt
    createdAt
    updatedAt
    mobileImage {
      id
      url
    }
    desktopImage {
      id
      url
    }
    mobileVideo {
      id
      status
      playlistUrl
      posterUrl
    }
    desktopVideo {
      id
      status
      playlistUrl
      posterUrl
    }
  }
}

